export type CookieConsentState = {
  version: string;
  preferences: boolean;
  analytics: boolean;
  decidedAt: string;
};

export const CONSENT_COOKIE_NAME = 'paydirt_cookie_consent';
export const THEME_COOKIE_NAME = 'paydirt_theme';
export const LEGACY_THEME_STORAGE_KEY = 'paydirt-theme';
